<template>
  <div>
    <v-card style="width:100%;" class="d-flex justify-center">
      <v-layout
        class="d-flex justify-center align-center pr-4"
        style="height:80px; width: 100%;"
      >
        <div class="d-flex align-center pl-5" style="width:100%; height:80px;">
          <h4
            style="color:gray; padding-right:4px;"
            @click="goBack()"
            class="go-back"
          >
            Account >
          </h4>
          <h4>Client</h4>
        </div>
        <v-btn
          color="secondary"
          style="color:white;"
          @click="switchClientType()"
          v-if="isAdmin"
          >{{ buttonText }}
        </v-btn>
      </v-layout>
    </v-card>
    <div class="d-flex">
      <div
        v-if="_client.client_name && !this.showMobileView"
        style="min-width:20%;"
        id="company-profile"
      >
        <account />
      </div>
      <div :style="formWidth">
        <client-form :data="clientData" :newClient="newClient" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ClientForm from './ClientForm.vue';
import Account from '@/components/Account.vue';
import { MobileView, UserPermissions } from '@/mixins';
import router from '../../router';

export default {
  components: {
    ClientForm,
    Account,
  },
  data: () => ({
    newClient: false,
  }),
  mixins: [MobileView, UserPermissions],
  methods: {
    ...mapActions({
      _getClientData: 'account/getClientData',
    }),
    switchClientType() {
      this.newClient = !this.newClient;
    },
    goBack() {
      router.push(
        `/${this._client.client_name.toLowerCase().replace(/\s/g, '')}/account`,
      );
    },
  },
  computed: {
    ...mapGetters({
      _client: 'account/getCurrentClient',
      _user: 'account/getCurrentUser',
    }),
    formWidth() {
      if (this.showMobileView) {
        return 'width:100%;';
      }
      return 'width:75%';
    },
    buttonText() {
      if (this.newClient) {
        return 'Go To Current Client';
      }
      return '+ Create A New Client';
    },
    clientData() {
      if (this.newClient) {
        return {
          name: '',
          logo_src: '',
          favicon_src: '',
          first_name: '',
          last_name: '',
          contact: {
            email: '',
            phone: '',
          },
          address: {
            address1: '',
            address2: '',
            state: '',
            country: '',
            zip: '',
          },
          style_attrs: {
            primary_color: '',
            secondary_color: '',
          },
        };
      }
      return this._client;
    },
  },
};
</script>

<style></style>
